// extracted by mini-css-extract-plugin
export default {"module":"rating_module__7Pupy","name":"rating_name__59uHU","phone":"rating_phone__7MXJV","policy":"rating_policy__oSJwt","button":"rating_button__FGmmt"};